<template>

  <div>

    <RenewCampaignEditorModal 
      ref="campaign-editor"
      @created="created_campaign"
      @updated="updated_campaign"
      :campaign_id="selected_campaign_id"
    />

  
    <m-row class="align-items-center mb-4 mt-8">
      <m-col sm="6" class="d-flex justify-end">
        <memlist-icon-button
          icon="menu-icon flaticon2-plus"
          :text="$t('MEMBER_RENEW_CAMPAIGN.CREATE')"
          variant="primary"
          @click="create_campaign_clicked"
        />
      </m-col>
    </m-row>

    <memlist-static-table
      id="campaigns-table"
      :fields="headers"
      :items="items"
      ref="campaigns-table"
    >

      <template #cell(status)="row">
        <memlist-badge status="none" v-if="row.item.status === 'DRAFT'">
          {{ $t('MEMBER_RENEW_CAMPAIGN.STATUSES.DRAFT') }}
        </memlist-badge>
        <memlist-badge status="warning" v-else-if="row.item.status === 'STARTUP'">
          {{ $t('MEMBER_RENEW_CAMPAIGN.STATUSES.STARTUP') }}
        </memlist-badge>
        <memlist-badge status="published" v-else-if="row.item.status === 'ACTIVE'">
          {{ $t('MEMBER_RENEW_CAMPAIGN.STATUSES.ACTIVE') }}
        </memlist-badge>
        <memlist-badge status="danger" v-else-if="row.item.status === 'ERROR'">
          {{ $t('MEMBER_RENEW_CAMPAIGN.STATUSES.ERROR') }}
        </memlist-badge>
        <memlist-badge status="primary" v-else-if="row.item.status === 'ARCHIVED'">
          {{ $t('MEMBER_RENEW_CAMPAIGN.STATUSES.ARCHIVED') }}
        </memlist-badge>
        <memlist-badge status="primary" v-else-if="row.item.status === 'FINISHED'">
          {{ $t('MEMBER_RENEW_CAMPAIGN.STATUSES.FINISHED') }}
        </memlist-badge>
      </template>

      <template #cell(actions)="row">
        <div class="justify-content-end d-flex">

          <memlist-table-button class="mr-3" @click="select_campaign_clicked(row.item.id)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')" />
          <memlist-table-button class="mr-3" @click="delete_campaign_clicked(row.item.id)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
        
        </div>
      </template>
    </memlist-static-table>
      
  </div>

</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import RenewCampaignEditorModal from './RenewCampaignEditorModal.vue';

export default {
  name: 'RenewCampaigns',
  mixins: [ toasts ],
  
  components: { 
    RenewCampaignEditorModal,
  },

  async mounted() {
    this.fetch_campaigns();
  },

  watch: {
    
    currentPeriodId() {
      this.fetch_campaigns();
    }
  },


  computed: {
    ...mapGetters([
      'currentCompanyId',
      'currentPeriodId',
      'currentUserId',
      'companies',
      'periods',
      'profile',
      'settings',
      'isTHS',
      'sid'
    ]),
  },

  methods: {
    created_campaign(item) {
      this.selected_campaign_id = item.id;
      this.fetch_campaigns();
    },
    updated_campaign(item) {
      this.fetch_campaigns();
    },
    create_campaign_clicked() {
      this.selected_campaign_id = null;
      this.$nextTick(()=>{
        this.$refs['campaign-editor'].show();
      });
    },
    async fetch_campaigns() {
      const res = await axios.get(`/member_renew/campaigns`);

      if (res.status === 200) {
        this.items = res.data.items;
      }
    },
    select_campaign_clicked(id) {
      this.selected_campaign_id = id;
      this.$nextTick(()=>{
        this.$refs['campaign-editor'].show();
      });
    },

    async delete_campaign_clicked(id) {
      const res = await axios.delete(`/member_renew/campaign/${id}`);

      if (res.status === 204) {
        this.toastr('success', this.$t('COMMON.OK'), this.$t('MEMBER_RENEW_CAMPAIGN.DELETED'));
      }
      else {
        this.toastr('success', this.$t('COMMON.OK'), this.$t('MEMBER_RENEW_CAMPAIGN.UNABLE_DELETE'));
      }
    }, 
  },

  data() {
    return {
      selected_campaign_id: null,
      items: [],
      current_page: 1,
      per_page: 100,
      options: [100, 150, 200],
      headers: [
        {
          key: 'name',
          label: this.$t('MEMBER_RENEW_CAMPAIGN.NAME'),
          sortable: true,
          thClass: 'td-overflow',
          tdClass: 'td-overflow'
        },
        {
          key: 'status',
          label: this.$t('MEMBER_RENEW_CAMPAIGN.STATUS'),
          sortable: true,
          thClass: 'td-short3',
          tdClass: 'td-short3',
        },
        {
          key: 'created_at',
          label: this.$t('MEMBER_RENEW_CAMPAIGN.CREATED_AT'),
          sortable: true,
          thClass: 'td-short3',
          tdClass: 'td-short3',
          formatter: (_, __, item) => {
            return dayjs(item.created_at).format('YYYY-MM-DD');
          }
        },
        {
          key: 'actions',
          label: this.$t('COMMON.ACTIONS'),
          thClass: 'td-short3',
          tdClass: 'td-short3'
        }
      ],
    }
  },

}
</script>

<style scoped>
.multiselect-blue {
  --ms-tag-bg: #DBEAFE;
  --ms-tag-color: #2563EB;
}

</style>